import {get as _get} from 'lodash';
import {GET_USER_MS_DATA, CLEAN_USER_MS_DATA} from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';
import initialState from '../initialstate';

export function userMSData(state = initialState.usersMSData, action) {
	switch (action.type) {
		case GET_USER_MS_DATA: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const user = action.response.value;
				if (!user?.length > 0) return state;
				const newState = [...(state instanceof Array ? state : [])];
				return [...newState, ...user];
			}
			return state;
		}
		case CLEAN_USER_MS_DATA: {
			return [];
		}
		default:
			return state;
	}
}
